import { render } from "./AllGrooms.vue?vue&type=template&id=5c96fedc"
import script from "./AllGrooms.vue?vue&type=script&lang=js"
export * from "./AllGrooms.vue?vue&type=script&lang=js"

import "./AllGrooms.vue?vue&type=style&index=0&id=5c96fedc&lang=css"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__